import React from "react";
import CommonButtons from "../../../../../../shared/components/CommonButtons";

interface PaymentActionsProps {
  onCancel: () => void;
  onComplete: () => void;
  backHomepay: (value: string) => void;
  isLoading?: boolean;
  receivedAmount: number;
  paymentMethod?: string;
  buttonLoading?: boolean;
  orderPriceData?: number;
}

const PaymentActions: React.FC<PaymentActionsProps> = ({ onCancel, onComplete, isLoading = false, receivedAmount, paymentMethod, buttonLoading, orderPriceData }) => {
const enabilePayment =()=>{
  return Number(orderPriceData ?? 0) <= 0? true :false;
} 

const paymentEnabile = enabilePayment()?false: receivedAmount <= 0

  const disableBtn = paymentMethod === "Cash" && paymentEnabile && !isLoading;

  return (
    <div className='flex justify-end w-full max-w-md mt-3 space-x-4' aria-busy={isLoading}>
      <CommonButtons className='w-36' label='Cancel' onClick={onCancel} variant='outlineDanger' disabled={isLoading} />
      <CommonButtons
        className='w-36'
        label={isLoading || buttonLoading ? "Please wait..." : "Complete"}
        onClick={onComplete}
        disabled={disableBtn || isLoading || buttonLoading}
      />
    </div>
  );
};

export default PaymentActions;
